<div class="loading-container order-history-block">
  <ng-template #SearchSortTool>
    <ng-container *ngIf="isCustomView()">
      <div class="row">
        <div class="col-md-8 mb-3">
          <label>Sort By</label>
          <select class="select-option" #sortSelect (change)="sortBy(sortSelect.value)">
            <option
              class="option"
              *ngFor="let option of sortOptionsMap | keyvalue"
              [value]="option.value"
              [selected]="option.value === selected"
            >
              {{ option.key }}
            </option>
          </select>
        </div>

        <div class="col-md-4">
          <ng-container *ishIsAuthorizedTo="'APP_B2B_MANAGE_USERS'">
            {{ changePlaceHolder() }}
          </ng-container>
          <ng-container *ngIf="searchPlaceHolder$ | async as searchPlaceHolder">
            <form (ngSubmit)="search(searchInput.value)" [formGroup]="form">
              <div class="input-group">
                <div class="form-outline">
                  <input
                    type="search"
                    #searchInput
                    class="form-control"
                    placeholder="{{ searchPlaceHolder$ | async }}"
                    [value]="searchTerm"
                  />
                </div>
                <button type="submit" class="btn btn-primary">
                  <i class="icon-search"></i>
                </button>
              </div>
            </form>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-template>
  <ng-container *ngIf="orders$ | async as ordersToDisplay">
    <ng-container *ngIf="ordersToDisplay?.length > 0; else emptyList">
      <ng-container *ngIf="ordersToDisplay?.length > 0; then SearchSortTool"></ng-container>

      <table
        cdk-table
        [dataSource]="ordersToDisplay"
        class="table table-lg mobile-optimized"
        data-testing-id="requisition-list"
        infiniteScroll
        (scrolled)="onScroll(ordersToDisplay?.length)"
        [alwaysCallback]="true"
        [immediateCheck]="true"
      >
        <!-- Order creation date -->
        <ng-container cdkColumnDef="creationDate">
          <th cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-creation-date">
            {{ 'account.orderlist.table.date_of_order' | translate }}
          </th>
          <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.date_of_order' | translate">
            {{ order.creationDate | ishDate }}
          </td>
        </ng-container>

        <!-- Order number -->
        <ng-container cdkColumnDef="orderNo">
          <th cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-number">
            {{ 'account.orderlist.table.order_number' | translate }}
          </th>
          <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.order_number' | translate">
            <ng-container *ngIf="orders?.length; else orderNumberWithLink">{{ order.documentNo }}</ng-container>
            <ng-template #orderNumberWithLink>
              <a [routerLink]="'/account/orders/' + order.id">{{ order.documentNo }}</a>
            </ng-template>
          </td>
        </ng-container>

        <!-- Buyer -->
        <ng-container cdkColumnDef="buyer">
          <th cdk-header-cell *cdkHeaderCellDef data-testing-id="th-buyer">
            <ng-container *ngIf="view === 'cost-center'; else buyerHeaderBasedOnRole">
              {{ 'account.orderlist.table.buyer' | translate }}
            </ng-container>

            <ng-template #buyerHeaderBasedOnRole>
              <ng-container *ishIsAuthorizedTo="'APP_B2B_MANAGE_USERS'">{{
                'account.orderlist.table.buyer' | translate
              }}</ng-container>
            </ng-template>
          </th>
          <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.buyer' | translate">
            <ng-container *ngIf="view === 'cost-center'; else buyersForOrderHistory">
              {{ getBuyerName(order.attributes) }}
            </ng-container>
            <ng-template #buyersForOrderHistory>
              <ng-container *ishIsAuthorizedTo="'APP_B2B_MANAGE_USERS'">
                {{ getBuyerNameUsingOrder(order) }}
              </ng-container>
            </ng-template>
          </td>
        </ng-container>

        <!-- Number of Items  -->
        <ng-container cdkColumnDef="lineItems">
          <th cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-items">
            {{ 'account.orderlist.table.items' | translate }}
          </th>
          <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.items' | translate">
            {{ order.lineItems?.length }}
          </td>
        </ng-container>

        <!-- Status  -->
        <ng-container cdkColumnDef="status">
          <th cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-status">
            {{ 'account.orderlist.table.order_status' | translate }}
          </th>
          <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.order_status' | translate">
            <span class="badge badge-info">{{ order.status }}</span>
          </td>
        </ng-container>

        <!-- Destination  -->
        <ng-container cdkColumnDef="destination">
          <th cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-destination">
            {{ 'account.orderlist.table.destination' | translate }}
          </th>
          <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.destination' | translate">
            <div *ngIf="order.buckets.length > 1">
              <p>{{ 'dias.account.orderlist.table.multiple.destination' | translate }}</p>
            </div>
            <div *ngFor="let shippingBucket of order.buckets">
              <ish-address [address]="shippingBucket.shipToAddress"></ish-address>
            </div>
          </td>
        </ng-container>

        <!-- Order total  -->
        <ng-container cdkColumnDef="orderTotal">
          <th cdk-header-cell *cdkHeaderCellDef class="text-right" data-testing-id="th-order-total">
            {{ 'account.orderlist.table.order_total' | translate }}
          </th>
          <td
            cdk-cell
            *cdkCellDef="let order"
            [attr.data-label]="'account.orderlist.table.order_total' | translate"
            class="column-price"
          >
            {{ order.totals.total | ishPrice : 'gross' }}
          </td>
        </ng-container>

        <!-- Header and Row Declarations -->
        <tr cdk-header-row *cdkHeaderRowDef="columnsToDisplay"></tr>
        <tr cdk-row *cdkRowDef="let row; columns: columnsToDisplay"></tr>
      </table>
    </ng-container>

    <ng-template #emptyList>
      <ng-container *ngIf="searchTerm; else emptyListWithoutSearch">
        <ng-container *ngIf="searchTerm; then SearchSortTool"></ng-container>
        <p data-testing-id="emptyList">{{ 'dias.order.search.noOrdersMessageKey' | translate }}</p>
      </ng-container>
    </ng-template>
    <ng-template #emptyListWithoutSearch>
      <p data-testing-id="emptyList">{{ noOrdersMessageKey | translate }}</p>
    </ng-template>
  </ng-container>

  <ish-loading *ngIf="loading$ | async"></ish-loading>
</div>
